class PropertyUtil {
  isChanged(original, changed) {
    if ((original && !changed) || (!original && changed)) {
      return true;
    }
    if (!original && !changed) {
      return false;
    }

    if (Array.isArray(original)) {
      if (!Array.isArray(changed)) {
        return true;
      }
      if (original.length != changed.length) return true;
      for (const o in original) {
        if (this.isChanged(original[o], changed[o])) {
          return true;
        }
      }

      for (const o in changed) {
        if (this.isChanged(original[o], changed[o])) {
          return true;
        }
      }

      return false;
    }

    if (typeof original == "object") {
      if (typeof changed != "object") {
        return true;
      }
      const originalKeys = Object.keys(original);
      for (const oKey of originalKeys) {
        if (!(oKey in changed)) {
          return true;
        }

        if (this.isChanged(original[oKey], changed[oKey])) {
          return true;
        }
      }

      const changedKeys = Object.keys(changed);
      for (const oKey of changedKeys) {
        if (!(oKey in original)) {
          return true;
        }

        if (this.isChanged(original[oKey], changed[oKey])) {
          return true;
        }
      }

      return false;
    }

    return original != changed;
  }

  getPropsDiff(original, _changed) {
    const changed = { ..._changed };

    [...Object.keys(original), ...Object.keys(changed)].forEach((key) => {
      if (key == "approval" || key == "effectedSystems") {
      }

      if (!this.isChanged(original[key], changed[key])) {
        delete changed[key];
      }
    });
    return changed;
  }
}

export default new PropertyUtil();
